(function() {
  var COOKIE = 'rqf_seen';
  var DAYS = 14;
  function getCookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )'+n+'=([^;]*)'));  return m ? decodeURIComponent(m[1]) : null; }
  function setCookie(n,v,d) { var e = new Date(); e.setTime(e.getTime()+d*864e5); document.cookie=n+'='+encodeURIComponent(v)+';expires='+e.toUTCString()+';path=/'; }
  var answers = { q1:null, q2:null, q3:[] };

  function init() {
    var delay = (window.rqfDelay||4)*1000;
    setTimeout(function(){ if(!getCookie(COOKIE)) rqfShow(); }, delay);
    var ov = document.getElementById('rqf-overlay');
    if(ov) ov.addEventListener('click', function(e){ if(e.target===this) rqfClose(); });
    window.rqfTrigger = rqfShow;
  }

  window.rqfShow = function() { var el=document.getElementById('rqf-overlay'); if(el) el.classList.add('rqf-visible'); };
  window.rqfClose = function() { var el=document.getElementById('rqf-overlay'); if(el) el.classList.remove('rqf-visible'); setCookie(COOKIE,'1',DAYS); };

  window.rqfSelect = function(step, btn) {
    document.querySelectorAll('#rqf-opts-'+step+' .rqf-opt').forEach(function(o){ o.classList.remove('rqf-selected'); });
    btn.classList.add('rqf-selected');
    if(step===1) answers.q1=btn.dataset.value;
    if(step===2) answers.q2=btn.dataset.value;
    var nb=document.getElementById('rqf-next-'+step); if(nb) nb.disabled=false;
  };

  window.rqfToggle = function(step, btn) {
    btn.classList.toggle('rqf-selected');
    var sel=[];
    document.querySelectorAll('#rqf-opts-3 .rqf-opt.rqf-selected').forEach(function(o){ sel.push(o.dataset.value); });
    answers.q3=sel;
    var nb=document.getElementById('rqf-next-3'); if(nb) nb.disabled=sel.length===0;
  };

  window.rqfNext = function(toStep) {
    document.querySelectorAll('.rqf-step').forEach(function(s){ s.style.display='none'; });
    var el=document.getElementById('rqf-step-'+toStep); if(el) el.style.display='block';
  };

  window.rqfBack = function(toStep) {
    rqfNext(toStep);
  };

  window.rqfCapture = function() {
    var name=document.getElementById('rqf-name');
    var email=document.getElementById('rqf-email');
    var phone=document.getElementById('rqf-phone');
    var bmonth=document.getElementById('rqf-bmonth');
    var byear=document.getElementById('rqf-byear');
    var err=document.getElementById('rqf-form-err');
    if(!name||!name.value.trim()){if(err)err.textContent='Please enter your name.'; return;}
    if(!email||!email.value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)){if(err)err.textContent='Please enter a valid email.'; return;}
    if(err) err.textContent='';
    var nameVal=name.value.trim(), emailVal=email.value.trim();
    var phoneVal=phone?phone.value.trim():'';
    var bmonthVal=bmonth?bmonth.value:'', byearVal=byear?byear.value:'';

    // Subscribe to Shopify email marketing
    var fd=new FormData();
    fd.append('form_type','customer');
    fd.append('utf8','✓');
    fd.append('contact[email]',emailVal);
    fd.append('contact[tags]','quiz_funnel');
    var note='Name: '+nameVal;
    if(phoneVal) note+='\nPhone: '+phoneVal;
    if(bmonthVal) note+='\nBirthday: '+bmonthVal+(byearVal?'/'+byearVal:'');
    fd.append('contact[body]',note);
    fetch('/contact',{method:'POST',body:fd,headers:{'Accept':'application/json'}}).catch(function(){});

    rqfFinish({
      name: nameVal,
      email: emailVal,
      phone: phoneVal,
      bmonth: bmonthVal,
      byear: byearVal
    });
  };

  window.rqfCopyCode = function() {
    var code = 'WELCOME10';
    if(navigator.clipboard) { navigator.clipboard.writeText(code); }
    else { var t=document.createElement('textarea'); t.value=code; document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); }
    var copyEl=document.querySelector('.rqf-discount-copy');
    var copiedEl=document.querySelector('.rqf-discount-copied');
    if(copyEl) copyEl.style.display='none';
    if(copiedEl) copiedEl.style.display='block';
    setTimeout(function(){ if(copyEl) copyEl.style.display=''; if(copiedEl) copiedEl.style.display='none'; }, 2000);
  };

  window.rqfFinish = function(profile) {
    setCookie(COOKIE,'1',DAYS);
    var recs=[], q3=answers.q3;
    if(q3.indexOf('supplements')!==-1) recs.push({icon:'💀',title:'Licked Pre-Workout',sub:"Baker's personal formula — 50 servings",url:'/products/licked'});
    if(q3.indexOf('accessories')!==-1) recs.push({icon:'🧤',title:'Super Heavy Wrist Wraps',sub:"60cm · Double-stitched · Baker's choice",url:'/products/super-heavy-wrist-wraps'});
    if(q3.indexOf('clothing')!==-1) recs.push({icon:'👕',title:'Reaper Clothing',sub:'Train in the brand',url:'/collections/clothing'});
    if(recs.length===0) recs.push({icon:'💀',title:'Shop The Graveyard',sub:'Find your weapon of choice',url:'/collections/all'});
    var gm={strength:['Built for strength.','The exact gear Baker uses to move serious weight.'],weight:['Train harder. Burn more.','Performance gear for your hardest sessions.'],muscle:['Built to grow.','Fuel the sessions that build real size.'],enjoy:['The Graveyard awaits.','Gear that makes every session worth showing up for.']};
    var g=gm[answers.q2]||['Built for you.',"Here's what Baker would reach for."];
    var rt=document.getElementById('rqf-res-title'); if(rt) rt.textContent=g[0];
    var rs=document.getElementById('rqf-res-sub'); if(rs) rs.textContent=g[1];
    var html='';
    recs.forEach(function(r){ html+='<a class="rqf-result-item" href="'+r.url+'" onclick="rqfClose()"><span class="rqf-result-item-icon">'+r.icon+'</span><div class="rqf-result-item-text"><div class="rqf-result-item-title">'+r.title+'</div><div class="rqf-result-item-sub">'+r.sub+'</div></div><span class="rqf-result-item-arrow">↦</span></a>'; });
    var rp=document.getElementById('rqf-res-products'); if(rp) rp.innerHTML=html;
    rqfNext('result');
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
